import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { Subject } from 'rxjs';
import { MatSnackBar } from "@angular/material/snack-bar"
import { FuseConfigService } from '../../../../@fuse/services/config/config.service';
import { fuseAnimations } from '../../../../@fuse/animations';
import { AuthenticationService } from '../authentication.service'
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'confirm-mail',
  templateUrl: './confirmmail.component.html',
  styleUrls: ['./confirmmail.component.scss'],
  animations: fuseAnimations
})
export class ConfirmMailComponent implements OnInit, OnDestroy {
  email: string;
  code: string;
  isConfirmSuccessfull: boolean; 
  isConfirmSuccessfullFlag: boolean = false;
  isAlreadyConfirmFlag: boolean;
  isReactivaionEmalSendFlag: boolean;
  message: string = ".";

  private unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */

  constructor(
    private readonly router: Router,
    private readonly snb: MatSnackBar,
    private readonly fuseConfigService: FuseConfigService,
    private readonly formBuilder: FormBuilder,
    private readonly authenticationService: AuthenticationService,
    private readonly route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {

    this.unsubscribeAll = new Subject();

    // Configure the layout
    this.fuseConfigService.config={
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    this.spinner.show();
    
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.code = params['code'];
    });

    if (this.email && this.code) {
      this.authenticationService.confirmMail(this.email, this.code).subscribe(result => {
        this.spinner.hide();
        this.isConfirmSuccessfullFlag = true;
        if (result.status === 1)
          this.isConfirmSuccessfull = true;
        else if (result.status === 2)
        {
          //this.isConfirmSuccessfull = false;
          this.isAlreadyConfirmFlag = true;
          this.message =  "Your email is already confirmed.";
        }
        else
          this.isConfirmSuccessfull = false;
      });
    }

  }

  reActivation() {
    this.authenticationService.reSendConfirmMail(this.email).subscribe(result => {
      this.spinner.hide();      
      if (result.status === 1) {
        this.isReactivaionEmalSendFlag = true;
        this.message = "Activation link has sent to your email please check.";
      }    
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.unsubscribeAll.next('');
    this.unsubscribeAll.complete();
  }
}
